export const GET_LDP_REQUEST= 'GET_LDP_REQUEST';
export const GET_LDP_SUCCESS= 'GET_LDP_SUCCESS';
export const GET_LDP_FAIL= 'GET_LDP_FAIL';
export const LDP_AVAILABLE_DATA_DATE= 'LDP_AVAILABLE_DATA_DATE';

export const SET_YEAR = 'SET_YEAR';
